import season from "../../assets/gallery/crafts/season.png";
import pipe_cleaners from "../../assets/gallery/crafts/pipe_cleaners.png";
import barnsley from "../../assets/gallery/crafts/barnsley.png";
import fans from "../../assets/gallery/crafts/fans.png";
import seals from "../../assets/gallery/crafts/seals.png";
import cats from "../../assets/gallery/crafts/cats.png";
import catbus from "../../assets/gallery/crafts/catbus.png";
import fans_draw from "../../assets/gallery/crafts/fans_draw.png";
import emily from "../../assets/gallery/crafts/emily.png";
import cat2d from "../../assets/gallery/crafts/cat2d.png";
import flower_paper from "../../assets/gallery/crafts/flower_paper.png";
import hanukkah from "../../assets/gallery/crafts/hanukkah.png";
import wave from "../../assets/gallery/crafts/wave.png";
import monkey_figurine from "../../assets/gallery/crafts/monkey_figurine.png";
import vessel from "../../assets/gallery/crafts/vessel.png";
import collection from "../../assets/gallery/crafts/collection.png";
import foucault from "../../assets/gallery/crafts/foucault.png";
import hammer from "../../assets/gallery/crafts/hammer.png";
import la_food_zine from "../../assets/gallery/crafts/la_food_zine.png";
import box from "../../assets/gallery/crafts/box.png";
import monster_figurine from "../../assets/gallery/crafts/monster_figurine.png";
import step_on from "../../assets/gallery/crafts/step_on.png";

const DataCrafts = [
	{src:season, name:season},
	{src:pipe_cleaners, name:pipe_cleaners},
	{src:barnsley, name:barnsley},
	{src:fans, name:fans},
	{src:seals, name:seals},
	{src:cats, name:cats},
	{src:catbus, name:catbus},
	{src:fans_draw, name:fans_draw},
	{src:emily, name:emily},
	{src:cat2d, name:cat2d},
	{src:flower_paper, name:flower_paper},
	{src:hanukkah, name:hanukkah},
	{src:wave, name:wave},
	{src:monkey_figurine, name:monkey_figurine},
	{src:vessel, name:vessel},
	{src:collection, name:collection},
	{src:foucault, name:foucault},
	{src:hammer, name:hammer},
	{src:la_food_zine, name:la_food_zine},
	{src:box, name:box},
	{src:monster_figurine, name:monster_figurine},
	{src:step_on, name:step_on},
]

export default DataCrafts;